export default __webpack_public_path__ + "static/media/img11.e782fdf8.jpeg";